import {
    addToChainBefore,
    ApiHandler,
    HandlerProps,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { chain, DispatchBeginLoadOrders as DispatchBeginLoadOrdersToOverride, RequestDataFromApi as RequestDataFromApiToOverride } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { OrderCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { getOrders } from "@rightstore/Services/OrderService";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach((original) => chain.push(original));
    });
}

type HandlerType = ApiHandler<GetOrdersApiParameter, OrderCollectionModel>;
type Props = {
    apiParameter: GetOrdersApiParameter;
    apiResult: OrderCollectionModel;
}

const AddExpands: HandlerType = (props: HandlerProps<GetOrdersApiParameter, Props>) => {
    props.apiParameter = {
        ...props.apiParameter,
        expand: ["orderLines"]
    };
};

export const DispatchBeginLoadOrders: HandlerType = props => {
    props.dispatch({
        type: "Data/Orders/BeginLoadOrders",
        parameter: { ...props.parameter, expand: ["orderLines"] },
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getOrders(props.apiParameter);
};

addToChainBefore(
    chain,
    DispatchBeginLoadOrdersToOverride,
    AddExpands
);

replaceInChain(
    chain,
    DispatchBeginLoadOrdersToOverride,
    DispatchBeginLoadOrders
);

replaceInChain(
    chain,
    RequestDataFromApiToOverride,
    RequestDataFromApi
);
